<template>
  <el-table-column
    :label="label"
    :prop="prop"
    class-name='transfer-month-day'
    :sortable="sortable"
    :placeholder="placeholder"
  >
    <template slot-scope="scope">
      <el-select
        v-model="scope.row.transfer_month_day"
        :placeholder="placeholder"
        :disabled="disabled"
        :autofocus="autofocus"
      >
        <el-option v-if="defaultBlank" label="" value="" />
        <el-option
          v-for="item in innerOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </template>
  </el-table-column>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: Date,
    label: {
      type: String,
      default: '振込日'
    },
    prop: {
      type: String,
      default: 'transfer_month_day'
    },
    mode: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    billing_ym: {
      type: String,
      default: 'billing_ym'
    },
    order: {
      type: String,
      default: 'order'
    },
    placeholder: {
      type: String,
      default: ''
    },
    defaultBlank: {
      type: Boolean,
      default: true
    }
  },
  data () {
    const rules = []
    if (!this.disabled) {
      if (this.required) {
        rules.push(this.validatorRangeRequired(this.label, 'change'))
      }
    }
    return {
      options: [],
      rules
    }
  },
  computed: {
    transferMonthDay: {
      get () {
        return this.value
      },
      set (transferMonthDay) {
        this.$emit('change', transferMonthDay)
      }
    },
    innerOptions: {
      get () {
        return this.setBillingYm()
      }
    }
  },
  async mounted () {
    // var list = []
    // var billingYm = this.billing_ym
    // var syoriFrom = 1
    // var syoriTo = 1
    // var orderBy = this.order
    // var dt = new Date(billingYm.substr(0, 4) + '/' + billingYm.substr(4, 2) + '/1')
    // var nextBillingYmd = new Date(dt.getFullYear(), dt.getMonth() + 1, dt.getDate())
    // var endOfMonth = new Date(nextBillingYmd - 1)
    // syoriTo = endOfMonth.getDate()
    // if (orderBy === 'ascending') {
    //   for (let i = syoriFrom; i <= syoriTo; i++) {
    //     list.push({ key: String(i), code_value: String(endOfMonth.getFullYear()) + '/' + String(endOfMonth.getMonth() + 1) + '/' + String(i) })
    //   }
    //   const billingDate = list
    //   const billingDateSet = [...new Set(billingDate.map((x) => x.code_value))]
    //   this.options = billingDateSet.map((x) => { return { value: x, label: x } })
    // }
    // if (orderBy === 'descending') {
    //   for (let i = syoriTo; i >= syoriFrom; i--) {
    //     list.push({ key: String(i), code_value: String(endOfMonth.getFullYear()) + '/' + String(endOfMonth.getMonth() + 1) + '/' + String(i) })
    //   }
    //   const billingDate = list
    //   const billingDateSet = [...new Set(billingDate.map((x) => x.code_value))]
    //   this.options = billingDateSet.map((x) => { return { value: x, label: x } })
    // }
  },
  methods: {
    setBillingYm () {
      var list = []
      var billingYm = this.billing_ym
      var syoriFrom = 1
      var syoriTo = 1
      var orderBy = this.order
      var dt = new Date(billingYm.substr(0, 4) + '/' + billingYm.substr(4, 2) + '/1')
      var nextBillingYmd = new Date(dt.getFullYear(), dt.getMonth() + 1, dt.getDate())
      var endOfMonth = new Date(nextBillingYmd - 1)
      syoriTo = endOfMonth.getDate()
      if (orderBy === 'ascending') {
        for (let i = syoriFrom; i <= syoriTo; i++) {
          list.push({ value: ('00' + i).slice(-2), label: String(endOfMonth.getFullYear()) + '/' + String(endOfMonth.getMonth() + 1) + '/' + String(i) })
        }
        // const billingDate = list
        // const billingDateSet = [...new Set(billingDate.map((x) => x.code_value))]
        // list = billingDateSet.map((x) => { return { value: x, label: x } })
      }
      if (orderBy === 'descending') {
        for (let i = syoriTo; i >= syoriFrom; i--) {
          list.push({ value: ('00' + i).slice(-2), label: String(endOfMonth.getFullYear()) + '/' + String(endOfMonth.getMonth() + 1) + '/' + String(i) })
        }
        // const billingDate = list
        // const billingDateSet = [...new Set(billingDate.map((x) => x.code_value))]
        // list = billingDateSet.map((x) => { return { value: x, label: x } })
      }
      return list
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.transfer-month-day {
      width: 12em;
    }
  }
}
</style>
